/**
 * "RETURN TO COMBAT" out-of-bounds warning, parked ~1/3 of the screen height up
 * from the bottom — between the centered {@link ClickPrompt} and the bottom
 * command-feedback badge. Shown while the player is outside the map boundary,
 * counting down the seconds remaining before a forced return to level flight.
 *
 * A red variant of the command-feedback / click-prompt badge; visibility and the
 * countdown text are driven each frame from {@link update} (CSS handles the
 * opacity transition).
 */
export default class OutOfBoundsWarning {
  constructor() {
    const el = document.createElement('div');
    el.id = 'oob-warning';
    this.el = el;
    this._lastText = '';
    document.getElementById('app').appendChild(el);
  }

  /**
   * @param {boolean} visible — show the warning this frame.
   * @param {number} secondsRemaining — countdown value rendered in the label.
   */
  update(visible, secondsRemaining = 0) {
    if (visible) {
      const text = `RETURN TO COMBAT  ${Math.max(0, Math.ceil(secondsRemaining))}`;
      if (text !== this._lastText) {
        this.el.textContent = text;
        this._lastText = text;
      }
    }
    this.el.classList.toggle('is-visible', visible);
  }

  dispose() {
    this.el.remove();
  }
}
